<template>
    <v-dialog v-model="dialog" max-width="800" transition="dialog-bottom-transition">
        <v-card>
            <v-card-title class="text-white green darken-1">
                考核配置
            </v-card-title>

            <v-card-text>
                <v-row class="mt-3" style="height: 400px;overflow-y: auto;"  v-scroll="onScroll">
                    <v-col cols="12">
                        <v-treeview
                            v-model="checkedTree"
                            :items="treeData"
                            activatable
                            item-key="id"
                            open-on-click
                            return-object
                            transition
                        >
                            <template v-slot:append="{ item }">
                                <v-checkbox v-model="item.isExam" />
                            </template>
                        </v-treeview>
                    </v-col>
                </v-row>
            </v-card-text>

            <v-divider></v-divider>

            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn text @click="dialog = false">
                    取消
                </v-btn>
                <v-btn color="primary" text @click="handleConfirm">
                    提交修改
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>

</template>

<script>
export default {
    props: {
        dialogExamConfig: {
            type: Boolean,
            default: false,
        },
        treeData: {
            type: Array,
            default: () => [],
        },
    },
    data() {
        return {
            checkedTree: [],
        }
    },
    computed: {
        dialog: {
            get() {
                return this.dialogExamConfig;
            },
            set(value) {
                this.$emit('update:dialogExamConfig', value);
            }
        },
    },
    methods: {
        onScroll() {
            console.log('onScroll');
        },
        selectModel(model) {
            this.selectedModels.push(model);
        },
        removeModel(model) {
            this.selectedModels = this.selectedModels.filter(item => item._id !== model._id);
        },
        handleConfirm() {
            console.log(this.checkedTree, this.treeData);
            this.$emit('confirm', this.checkedTree);
        }
    }
}
</script>